import React, { useRef, useEffect, useCallback, useState } from "react";
import { createUseStyles } from "react-jss";
import LeftOptions from "./components/LeftOptions";
import Sections from "./components/Sections";

const useStyles = createUseStyles({
  wrapper: {
    overflow: "hidden",
    backgroundColor: "white",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    height: "100vh"
  },
  sectionsWrap: {
    overflowY: "scroll",
    width: "75%",
    padding: "2rem 3rem 2rem 3rem",
    position: 'relative',

    "@media (max-width: 700px)": {
      width: "60%"
    },
    "@media (max-width: 350px)": {
      width: "100%"
    }
  },
  boxBlue: {
    width: "100%",
    height: "10%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#55c57a"
  },
  title: {
    color: "#fff",
    fontFamily: "'Lucida Console', Courier, monospace"
  },
  leftWrapper: {
    width: "100%",
    height: "90%",
    display: "flex",
    flexDirection: "row"
  }
});

const ClickAndScroll = ({sections}) => {
  // toggle show modal with checkboxes
  const classes = useStyles();
  const [activeSection, handleChangeActiveSection] = useState(0);
  const [clickedSection, handleClickSection] = useState(false);
  const elementsRef = useRef([]);
  const filtersWrap = useRef(null);

  /** Function will change the active section onScrolling */
  const handleChangeActive = useCallback(() => {
    const scrollDistance =
      filtersWrap && filtersWrap.current && filtersWrap.current.scrollTop
        ? filtersWrap.current.scrollTop
        : 0;
    let index = 0;
    let condition = false;
    let i = 0;

    while (!condition && i <= sections.length - 1) {
      const som = elementsRef.current[i].offsetTop +
            elementsRef.current[i].offsetHeight;

      if (som && scrollDistance < som && !condition) {
        index = i;
        condition = true;
      }
      i++;
    }
    handleChangeActiveSection(index);
  }, [handleChangeActiveSection, sections.length]);

  // Hook for changing active section when scrolling
  useEffect(() => {
    if (filtersWrap.current) {
      filtersWrap.current.addEventListener("scroll", handleChangeActive);
    }

    // returned function will be called on component unmount
    return () => {
      if (filtersWrap.current) {
        filtersWrap.current.removeEventListener("scroll", handleChangeActive);
      }
    };
  }, [handleChangeActive]);

  // hook to scroll to section when click section on sidebar
  useEffect(() => {
    if (clickedSection) {
      if (filtersWrap.current) {
        filtersWrap.current.removeEventListener("scroll", handleChangeActive);
      }

      if (elementsRef.current[activeSection] !== null) {
        elementsRef.current[activeSection].scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }

      if (filtersWrap.current) {
        filtersWrap.current.addEventListener("scroll", handleChangeActive);
      }

      handleClickSection(false);
    }
  }, [clickedSection, activeSection, handleChangeActive, handleClickSection]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.boxBlue}>
        <h1 className={classes.title}>Scroll & Click</h1>
      </div>
      <div className={classes.leftWrapper}>
        <LeftOptions
          activeSection={activeSection}
          handleChangeActiveSection={handleChangeActiveSection}
          handleClickSection={handleClickSection}
          sections={sections}
        />
        <div ref={filtersWrap} className={classes.sectionsWrap}>
          <Sections elementsRef={elementsRef} sections={sections} />
        </div>
      </div>
    </div>
  );
};

export default ClickAndScroll;
